// 枠別に最大持込点数を定義
export const MAX_QTY_FOR_30_MINUTES_FRAME = 2
export const MAX_QTY_FOR_60_MINUTES_FRAME = 6
export const MAX_QTY_FOR_90_MINUTES_FRAME = 9
export const MAX_QTY_FOR_120_MINUTES_FRAME = 12
